var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-container"},[_c('div',{staticClass:"number"},[_c('span',[_vm._v(_vm._s(_vm.index))])]),(_vm.$slots.default)?_c('div',{staticClass:"title"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }